<template>
  <div class="w-100 m-0 d-flex justify-content-center">
    <div class="container-inputs p-3">
      <h4 class="display-5 text-white title">Login</h4>
      <form class="space-y-4" @submit.prevent="submit">
        <div>
          <label for="code" class="text-sm text-white">Code from SMS</label>
          <input type="text" id="code" name="code" v-model="code" ref="code"
            class="w-100 px-2 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
            autocomplete="off" />
        </div>
        <div>
          <button type="submit"
            class="w-100 btn btn-primary mt-3 px-2 py-2 tracking-wide text-white transition-colors duration-200 transform bg-purple-700 rounded-md hover:bg-purple-600 focus:outline-none focus:bg-purple-600">
            Confirm
          </button>
        </div>
      </form>
      <div class="text-center mt-2">
        <RouterLink to="/2fa/yubikey" class="font-medium text-white hover:underline">Yubikey</RouterLink>
      </div>

      <div class="text-center">
        <RouterLink to="/2fa/authenticator" class="font-medium text-white hover:underline">Authenticator</RouterLink>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { getCustomerStorage, setCustomer, isKnab, updateAppearanceKnab } from '@/App.vue';

import $ from "jquery";

export default {
  name: 'SmsPage',
  data() {
    return {
      code: '',
    }
  },
  methods: {
    async submit() {
      try {
        const response = await this.$http.post('/2fa/sms', {
          code: this.code,
        });

        getCustomerStorage().setItem('token', response.data.access_token);
        setCustomer(response.data.customer);

        this.$http.get('/dashboard')
          .then((response) => {
              // Deze functie verzorgt de opmaak van het hamburgermenu met een bolletje en het aantal notificiaties voor de gebruiker
              this.$hasActions(response.data);
          })
          .catch((error) => {
              console.log(error);
          });
          
        $(".hamburger-authentication").show();

        this.emitter.emit('login', true);

        await this.$router.push({ path: '/' });
      } catch (error) {
        console.error(error)

        this.code = ''

        this.$refs.code.focus()
      }
    }
  },
  async mounted() {
    if(isKnab()) {
      updateAppearanceKnab();
      $(".text-white").removeClass("text-white");
    }

    this.$refs.code.focus()

    try {
      await this.$http.get('/2fa/sms')
    } catch (error) {
      console.error(error)
    }
  }
}
</script>
